import React from 'react';
import { useUserDisplayNameQuery } from '@uplift/queries';


export const UserName: React.VFC<{ providerId: string }> = ({ providerId }) => {
  const { data } = useUserDisplayNameQuery(providerId, { suspense: true });

  return <>{data.fullLegalName}</>;
};
